export const SINGLE_DAY_SAVE_FORMAT = 'y-MM-dd';
